import { BrokerPortfolioStatusesEnum } from 'dash-common';
import { IconKeys, mainTheme } from 'dash-ui';

export const PORTFOLIO_STATUSES_OPTIONS: Record<
  BrokerPortfolioStatusesEnum,
  { icon: IconKeys; color: string }
> = {
  [BrokerPortfolioStatusesEnum.PRIVATE]: {
    icon: 'visibilityOff',
    color: mainTheme.colors.b50,
  },
  [BrokerPortfolioStatusesEnum.PUBLIC]: {
    icon: 'check',
    color: mainTheme.colors.g20,
  },
};

export const PORTFOLIO_STATUSES_OPTIONS_PASSWORD: {
  icon: IconKeys;
  color: string;
} = {
  icon: 'lock',
  color: mainTheme.colors.g20,
};
